module.exports = __webpack_public_path__ + "img/constant-contact-logo.8bdcc37c.jpg";